import { jsx as t } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import i from "./index.es5728.js";
import { BodyText as n } from "./index.es505.js";
const l = a(
  ({ children: r, testId: o, ...e }, m) => /* @__PURE__ */ t("button", { className: i.button, ref: m, "data-testid": o, ...e, children: /* @__PURE__ */ t(n, { color: "primary-brand", variant: "semi-bold", element: "p", children: r }) })
);
export {
  l as CtaButton
};
//# sourceMappingURL=index.es863.js.map
